import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS, TESTIMONIALS } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

const Counter = ({ target }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const end = parseInt(target, 10);
    const start = Date.now();
    const dur = 1400;
    let raf;
    const tick = () => {
      const p = Math.min((Date.now() - start) / dur, 1);
      setN(Math.floor((1 - Math.pow(1 - p, 3)) * end));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);
  return <span ref={ref}>{n}</span>;
};

export const Studio = () => (
  <section
    id="studio"
    data-testid="studio-section"
    className="border-t border-white/10"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 sm:py-32">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 border-b border-white/10 pb-20">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div data-testid={`stat-${i}`} className="text-left">
              <div className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light text-[#F4F3F0] leading-none">
                <Counter target={s.value} />
                <span className="text-[#C05C3F] text-3xl align-top ml-1">
                  {s.suffix}
                </span>
              </div>
              <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.15em] text-[#F4F3F0]/50">
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-20">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-${i}`}
              className="h-full border border-white/10 p-8 flex flex-col justify-between bg-[#1C1C1A] hover:border-[#C05C3F]/40 transition-colors duration-500"
            >
              <blockquote className="font-serif text-xl sm:text-2xl font-light italic text-[#F4F3F0] leading-snug">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8">
                <div className="text-sm text-[#F4F3F0]">{t.name}</div>
                <div className="font-mono text-[11px] uppercase tracking-[0.15em] text-[#C05C3F] mt-1">
                  {t.project}
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
